import { Theme } from "../../../components/constants";

export default {
    text: {
        fontSize: "14px",
        color: Theme.TEXT_PRIMARY_BLACK
    },
    actionsRow: {
        marginTop: '20px', 
        display: 'flex',
        gap: '15px' 
    },
    grid: { 
        padding: '30px 10px' 
    },
    W8W9DetailsPopupCustom: {
		maxHeight: "95vh",
		display: "flex",
		flexDirection: "column",
		width: '50vw',
		maxWidth: '50vw'
	},
	W8W9DetailsPopupChildren: {
		maxHeight: "100%",
		paddingBottom: '50px'
	},
    W8W9HeadingRow: {
        display: 'flex', 
        gap:"20px", 
        alignItems: 'center'
    }
}